module.exports = __webpack_public_path__ + "@/assets/img/scroll.2da5b2a9.png";